// extracted by mini-css-extract-plugin
export default {"container":"edit-abilities_container__BH9Pt","list":"edit-abilities_list__MP-59"};